<template>
  <div class="app-aside bg-white h-100">
    <el-menu class="el-menu-vertical-demo h-100 overflow-hidden" :router="true" :default-active="activePath"
      :default-openeds="['/', '1', '2', 'mall', 'service', 'my']" :unique-opened="false">
      <el-menu-item index="/">
        <i class="el-icon-house"></i>
        <span slot="title">首页</span>
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-edit"></i>
          <span>创作</span>
        </template>
        <el-menu-item index="/article/create?type=1">
          <span slot="title" class="ps-2">写文章</span>
        </el-menu-item>
        <el-menu-item index="/article/create?type=2">
          <span slot="title" class="ps-2">发视频</span>
        </el-menu-item>
        <!-- <el-menu-item index="/h5maker/home">
          <span slot="title" class="ps-2">新建页面</span>
        </el-menu-item> -->
      </el-submenu>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-news"></i>
          <span>内容</span>
        </template>
        <el-menu-item index="/article/">
          <span slot="title" class=" ps-2">作品管理</span>
        </el-menu-item>
        <el-menu-item index="/material">
          <span slot="title" class=" ps-2">素材管理</span>
        </el-menu-item>
        <!-- <el-menu-item index="/h5maker/all">
          <span slot="title" class=" ps-2">页面管理</span>
        </el-menu-item> -->
      </el-submenu>
      <!-- <el-submenu index="mall">
        <template slot="title">
          <i class="el-icon-goods"></i>
          <span>店铺</span>
        </template>
        <el-menu-item index="/mall/items/">
          <span slot="title" class=" ps-2">商品</span>
        </el-menu-item>
        <el-menu-item index="/mall/orders/">
          <span slot="title" class=" ps-2">订单</span>
        </el-menu-item>
        <el-menu-item index="/mall/customers/">
          <span slot="title" class=" ps-2">客户</span>
        </el-menu-item>
        <el-menu-item index="/mall/settings/">
          <span slot="title" class=" ps-2">设置</span>
        </el-menu-item>
      </el-submenu> -->
      <!-- <el-menu-item index="/agency">
        <i class="el-icon-guide"></i>
        <span slot="title">商家中心</span>
      </el-menu-item> -->
      <!-- <el-submenu index="h5maker">
        <template slot="title">
          <i class="bi bi-files"></i>
          <span>页面秀</span>
        </template>
        <el-menu-item index="/h5maker/">
          <span slot="title" class=" ps-2">工作台</span>
        </el-menu-item>
      </el-submenu> -->
      <!-- <el-submenu index="service">
        <template slot="title">
          <i class="bi bi-database"></i>
          <span>服务</span>
        </template>
        <el-menu-item index="/agency/">
          <span slot="title" class=" ps-2">电话线索</span>
        </el-menu-item>
        <el-menu-item index="/agency/">
          <span slot="title" class=" ps-2">询价线索</span>
        </el-menu-item>
        <el-menu-item index="/agency/">
          <span slot="title" class=" ps-2">认证信息</span>
        </el-menu-item>
      </el-submenu> -->

      <el-submenu index="my">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>我的</span>
        </template>
        <el-menu-item index="/account/">
          <span slot="title" class=" ps-2">账户设置</span>
        </el-menu-item>
        <el-menu-item index="/notification">
          <span slot="title" class=" ps-2">消息通知</span>
        </el-menu-item>
      </el-submenu>

      <!-- <el-submenu index="2">
        <template slot="title">
            <i class="el-icon-truck"></i>
            <span>二手车管理</span>
          </template>
        <el-menu-item index="/article/">
          <i class="el-icon-money"></i>
          <span slot="title">我要卖车</span>
        </el-menu-item>
        <el-menu-item index="/article/">
          <i class="el-icon-document"></i>
          <span slot="title">车库</span>
        </el-menu-item>
        <el-menu-item index="/material">
          <i class="el-icon-goods"></i>
          <span slot="title">购车意向</span>
        </el-menu-item>
        <el-menu-item index="/comments/">
          <i class="el-icon-chat-square"></i>
          <span slot="title">评论</span>
        </el-menu-item>
      </el-submenu> -->

    </el-menu>
  </div>
</template>
<script>
import ArticleService from "@/service/ArticleService.js";
export default {
  data() {
    return {
      list: [
        {
          title: "车型库",
          class: "fa fa-truck text-muted",
          active: true,
        },
      ],
      isPirce: false,
      activePath: this.$route.path,
    };
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    async goPublish(type) {
      const res = await ArticleService.addRaft({ type });
      this.$router.push({
        name: "Publish",
        params: {
          id: res.data
        }
      });
    }
  },
  watch: {
    $route: "init",
  },
};
</script>
<style scoped>
.el-menu-item:hover {
  background: rgba(0, 0, 0, 0.03);
}

.el-menu-item:focus {
  background: rgba(0, 0, 0, 0.03);
}

.el-menu-item i,
.el-submenu__title i {
  color: #303133;
}
.el-submenu .bi {
    vertical-align: middle;
    margin-right: 10px;
    width: 24px;
    text-align: center;
    font-size: 18px;
}
</style>
